/**
 * Utility functions for generating temporary passwords
 */

/**
 * Generates a temporary password that is secure and user-friendly
 * @returns {string} Temporary password in format: 2 letters + 4 digits + 2 letters
 */
export function generateTemporaryPassword() {
  // Generate 2 random uppercase letters
  const letters1 = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + 
                   String.fromCharCode(65 + Math.floor(Math.random() * 26));
  
  // Generate 4 random digits
  const digits = Math.floor(1000 + Math.random() * 9000);
  
  // Generate 2 random lowercase letters
  const letters2 = String.fromCharCode(97 + Math.floor(Math.random() * 26)) + 
                   String.fromCharCode(97 + Math.floor(Math.random() * 26));
  
  // Combine: 2 uppercase + 4 digits + 2 lowercase (e.g., "AB1234cd")
  return `${letters1}${digits}${letters2}`;
}

/**
 * Validates if a password meets security requirements
 * @param {string} password - The password to validate
 * @returns {object} Object with isValid boolean and message string
 */
export function validatePassword(password) {
  if (!password) {
    return { isValid: false, message: 'Password is required' };
  }
  
  if (password.length < 8) {
    return { isValid: false, message: 'Password must be at least 8 characters' };
  }
  
  if (!/(?=.*[a-z])/.test(password)) {
    return { isValid: false, message: 'Password must contain at least one lowercase letter' };
  }
  
  if (!/(?=.*[A-Z])/.test(password)) {
    return { isValid: false, message: 'Password must contain at least one uppercase letter' };
  }
  
  if (!/(?=.*\d)/.test(password)) {
    return { isValid: false, message: 'Password must contain at least one number' };
  }
  
  return { isValid: true, message: 'Password is valid' };
} 